export const CHIT_STATUS_TABS = [
  { key: "pending", label: "Pending", status: "PendingPosting" },
  {
    key: "authorisation",
    label: "Authorisation",
    status: "PendingAuthorization",
  },
  { key: "rejected", label: "Rejected", status: "Rejected" },
  { key: "unallocated", label: "Unallocated", status: "Unallocated" },
  { key: "posted", label: "Posted", status: "Posted" },
];

export const PostingStatus = [
  { label: "Unposted", value: "false" },
  { label: "Posted", value: "true" },
  { label: "All", value: "" },
];
